
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {EOrderStatuses, IOrder} from "@/model/Order/orderInterfaces";
import {namespace} from "vuex-class";
import LCChooser from "@/components/locker/widget/LCChooser.vue";
import {IOnOffHandlers} from "bonomo/dist";
import Vue from "vue";

const lockerModule = namespace("lockerModule");
const orderModule = namespace("orderModule");

@Component({
  components: {
    LCChooser,
  }
})
export default class OONewCellButton extends Vue {

  @Prop()
  protected order!: IOrder;

  @lockerModule.Getter('availableCells')
  private availableCells!: any;
  @lockerModule.Action('availableCells')
  private fetchAvailableCells!: (lockerId: number) => any;
  @orderModule.Action('assignNewCell')
  protected assignNewCell!: (params: {orderId: number, lockerCellSizeId: number}) => void;

  protected selectedCellSizeId = 0;

  protected get orderHasCellError(): boolean {
    const hasCell = this.hasCell;
    const statuses = [
      EOrderStatuses.status_order_in_route_delivery,
      EOrderStatuses.status_order_assembled,
    ];
    if (statuses.includes(this.order.status) && !hasCell) {
      return true;
    }
    return false;
  }

  protected get showButton(): boolean {
    // UI exception: never show this button for lagoon
    if (this.order.channel_id == 4) {
      return false;
    }
    return true;
  }

  protected get hasCell(): boolean {
    const cell = this.order.currentCell;
    return !!cell && !!cell.id;
  }

  protected get buttonDisabled(): boolean {
    const invalidStatuses = [
        EOrderStatuses.status_order_new,
        EOrderStatuses.status_order_completed,
    ];
    return invalidStatuses.includes(this.order.status);
  }

  protected get buttonColor(): string {
    const hasCell = this.hasCell;
    const hasError = this.orderHasCellError;
    const buttonDisabled = this.buttonDisabled;
    if (hasError) {
      return 'error';
    }
    else if (buttonDisabled || !hasCell) {
      return 'disabled';
    }
    else return 'light-blue';
  }

  protected get buttonTitle(): string {
    const hasError = this.orderHasCellError;
    return hasError
      ? this.$t('orders.order.CTA.newLockerCell.errorTitle') as string
      : this.$t('orders.order.CTA.newLockerCell.title') as string;

  }

  protected get buttonIcon(): string {
    const hasError = this.orderHasCellError;
    const hasCell = this.hasCell;
    if (hasError) {
      return this.$icons.alert;
    }
    else if (hasCell) {
      return this.$icons.lockers.cells.cells;
    }
    return 'mdi-minus-circle-off';
  }

  protected get disabledCellSizeIds(): number[] {
    return this.order.currentCell ? [this.order.currentCell.cell_size_id] : [];
  }

  protected showDialog = false;
  protected loading = false;
  private subscribes: IOnOffHandlers = {};

  protected created() {
    this.subscribes = this.$ons({
      'backend.call.OK.availableCellsLoaded': this.onCellsLoaded,
      'backend.call.KO.availableCellsLoaded': this.onCellsLoaded,
      'backend.call.OK.orderLoaded': this.onOK,
      'backend.call.KO.orderLoaded': this.onKO,
    });
  }

  protected beforeDestroy() {
    this.$offs(this.subscribes);
  }

  protected onActivatorClicked() {
    // detail: the button is not shown now for eg. an amazon order which awaits customer dropoff, as there
    //  is no location in order response yet
    let lockerId = 0;
    if (this.order.pickupLocation && this.order.pickupLocation.type == 'locker') {
      lockerId = this.order.pickupLocation.id;
    }
    else if (this.order.deliveryLocation && this.order.deliveryLocation.type == 'locker') {
      lockerId = this.order.deliveryLocation.id;
    }
    if (lockerId != 0) {
      this.loading = true;
      this.fetchAvailableCells(lockerId);
      this.selectedCellSizeId = 0;
    }
    else {
      this.$comingUp();
      this.$nextTick(() => this.showDialog = false);
    }
  }

  protected onSubmit() {
    this.loading = true;
    this.assignNewCell({
      orderId: this.order.id,
      lockerCellSizeId: this.selectedCellSizeId,
    });
  }

  protected onCancel() {
    this.showDialog = false;
  }

  protected onOK() {
    this.$uiBus.emit('success', 'OK');
    this.loading = false;
    this.showDialog = false;
  }

  protected onKO() {
    this.loading = false;
  }

  private onCellsLoaded() {
    this.loading = false;
  }

}

